import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/doubleQuotes.png'


const _withScopeId = n => (_pushScopeId("data-v-412b461a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "boxs" }
const _hoisted_2 = { id: "box_title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  id: "box_icon",
  src: _imports_0
}, null, -1))
const _hoisted_4 = ["id"]
const _hoisted_5 = ["v-if"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.$props.items, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        id: "box_bg",
        key: index
      }, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(item.title), 1),
        _hoisted_3,
        _createElementVNode("div", {
          id: _ctx.des_bold ? 'box_des_bold' : 'box_des'
        }, _toDisplayString(item.des), 9, _hoisted_4),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.rules, (rule, j) => {
          return (_openBlock(), _createElementBlock("div", {
            id: "box_rule",
            "v-if": item.rules,
            key: `box_rule_${j}`
          }, _toDisplayString(rule), 9, _hoisted_5))
        }), 128))
      ]))
    }), 128))
  ]))
}